/* 布局 */
//前台
import Layout from "@views/layout";

const plaparcurriculumRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "plaparcurriculum/list",
        name: "PLAPARCURRICULUM",
        meta: {
            title: "家长课程",
        },
        component: () => import("@views/business/plaparcurriculum/index.vue"),
    },
        ],
};

export default plaparcurriculumRouter;
